import { useState } from "react";
import { Upload, X, FileText, Loader2 } from "lucide-react";
import { api, resolveUrl } from "@/lib/api";
import { toast } from "sonner";

export const FileUpload = ({ value, onChange, accept = "image/*", kind = "image" }) => {
  const [uploading, setUploading] = useState(false);

  const handle = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    setUploading(true);
    try {
      const res = await api.upload(file);
      onChange(res.url);
      toast.success("Uppladdad!");
    } catch {
      toast.error("Uppladdning misslyckades");
    } finally {
      setUploading(false);
    }
  };

  return (
    <div>
      {value ? (
        <div className="relative inline-flex items-center gap-3 rounded-lg border border-white/15 bg-black/40 p-2 pr-3">
          {kind === "image" ? (
            <img src={resolveUrl(value)} alt="" className="h-14 w-14 rounded object-cover" />
          ) : (
            <div className="h-14 w-14 grid place-items-center rounded bg-amber-500/10 text-amber-500"><FileText className="w-6 h-6" /></div>
          )}
          <span className="text-xs text-white/60 max-w-[160px] truncate">{value.split("/").pop()}</span>
          <button type="button" onClick={() => onChange("")} className="p-1 text-white/40 hover:text-red-500"><X className="w-4 h-4" /></button>
        </div>
      ) : (
        <label className="inline-flex cursor-pointer items-center gap-2 rounded-lg border border-dashed border-white/20 px-4 py-3 text-sm text-white/60 hover:border-amber-500/60 hover:text-amber-500 transition-colors">
          {uploading ? <Loader2 className="w-4 h-4 animate-spin" /> : <Upload className="w-4 h-4" />}
          {uploading ? "Laddar upp..." : kind === "image" ? "Ladda upp bild" : "Ladda upp fil (PDF)"}
          <input type="file" accept={accept} className="hidden" onChange={handle} disabled={uploading} />
        </label>
      )}
    </div>
  );
};
